import React, { useEffect, useState } from 'react'
import { PaginationContent } from './components/PaginationContent'
import { DataLoaderGlobalParams } from '@news-mono/web-common'
import { useLocation } from 'react-router-dom'
import { breakpoints, useWindowWidth } from '@news-mono/component-library'
import { usePagination } from './usePagination'

export interface PaginationProps {
    contextId: string
    services: DataLoaderGlobalParams
}

/** A pagination component for The Nightly. */
export const Pagination = ({ contextId, services }: PaginationProps) => {
    const { pathname } = useLocation()

    const { collectionData, paging, setPage } = usePagination(
        contextId,
        services,
    )

    if (!collectionData.loaded) {
        return null
    }

    const { result } = collectionData

    if (
        !(result.kind === 'listing' || result.kind === 'edition') ||
        !result.total
    ) {
        return null
    }

    return (
        <PaginationContent
            currentPage={paging.page}
            pageSize={paging.pageSize}
            publicationCount={result.total}
            setPage={setPage}
            path={pathname}
        />
    )
}
